import { type GkAirRecommendedProductDataWeb } from '@redteclab/api/clients/crosssellers-proxy-service'

import { apmCaptureError } from '../../apm'
import { type LOCALE } from '../../i18n'

import { gkAirAccessorGetUnderscoreLocale } from './gkAirAccessorGetUnderscoreLocale'

export const gkAirAccessorGetLocalizedProductImageUrl = ({
  locale,
  product,
}: {
  locale: LOCALE
  product: GkAirRecommendedProductDataWeb
}): string => {
  const productImageUrl =
    product[`image_url_${gkAirAccessorGetUnderscoreLocale(locale)}`]

  if (!productImageUrl) {
    apmCaptureError(
      new Error(
        `GK_AIR: product image url not found for "${product.UID}" for ${locale}`,
      ),
    )

    return ''
  }

  return productImageUrl
}
